<template lang="pug">
.popup-notice
  .wrapper
    close-btn(@clicked="$emit('close')")
    .title 服务须知
    .terms
      .term
        .title 门票购买/兑换
        .body
          .copy 1.	由于空间站内空间有限，为更好提升用户游览体验，出于游客安全和防控疫情需要，空间站实行按时段预约制。
          .copy 2.	您须已满十八周岁，并请使用您本人实名认证的支付宝帐号购买门票。
          .copy 3.	您应仅为您本人购买门票；但为满足部分用户的家庭购票需求，您可以同时为您自己的家人（上限为一名成年人及两名未成年子女）购票。
          .copy 4.	您可以使用您的支付宝积分（以下简称“积分”）兑换空间站门票，或通过积分兑换与支付宝支付结合的方式购买。因支付宝会员等级不同，票价及兑换需使用的积分也不同，具体请见购票详情页。
          .copy 5.	为了提升用户体验，我们可能需调整票品的类型和购买/兑换规则，并将提前7个自然日公示；但在调整前您已购买或兑换的票不受影响。
          .copy 6.	如您对门票购买/兑换有任何疑问，欢迎咨询【支付宝客服-95188】。
      .term
        .title 修改预约时间/退票
        .body
          .copy 1.	如您的行程安排有变，您可至少在入场前    天内选择变更预约时间。为满足更多用户的参观需求，仅可改签一次。
          .copy 2.	所有门票在核销前均支持退票，您可通过本程序按照页面提示操作退票。退票后，您已支付的现金/已兑换的积分将在【3-7】个工作日内原路退回。如您已在空间站核销，无论您是否实际游览，门票将不支持退改。
      .term
        .title 游览空间站注意事项
        .body
          .copy 1.	为更好提升用户的游览体验、出于游客安全和防控疫情的需要，我们期待并欢迎您在预约的时间段内来到本空间站。如您无法在预约的时间段到来，我们将无法保证您能及时进入。为此带来的不便，请您谅解。
          .copy 2.	空间站内的展项内容以参展前本程序页面公示的为准。因防控疫情、设备维护等原因，我们可能暂时关闭空间站、调整空间站内展项和设施的开放时间、控制进站人数、暂停或取消部分或全部服务。如果发生需要暂时关闭空间站的事宜，我们将尽可能提前在本程序相关页面上公示相关信息。
          .copy 3.	出于维护空间站安全、参展秩序、防控疫情或者其它必要的考虑，我们可能会拒绝个别游客进入空间站或要求个别游客离开空间站。
          .copy 4.	进入空间站及游览过程中，您同意遵守空间站的场馆规定、设备使用规则，听从现场工作人员的引导、指示。
      .term
        .title 飞跃蚂蚁森林等特殊项目的特别提示
        .body
          .copy 1.  禁止60周岁以上长者、醉酒、高血压、心脏病、眩晕症、脊柱病患者、孕妇、行动不便   及其他不适合身体剧烈运动者乘坐。
          .copy 2.  1米以下和1.2米以上儿童不得乘坐。身高1米-1.2米之间的儿童必须有成人陪同才能乘坐。
          .copy 3.  请按次序排队上下，听从工作人员指挥，不得争先恐后和翻越闸机。
          .copy 4.  乘坐时禁止携带易脱落、易碎物品，如手机、眼镜等，请妥善保管。
          .copy 5.  用户就位背靠后，请系好安全带并配合工作人员进行安全检查。
          .copy 6.  设备运转中要保持正确坐姿，紧握扶手，不要擅自解开安全带。严禁抛洒杂物、乱摇乱晃，站立及做出各种危险动作。
          .copy 7.  请您听从工作人员的安排。违反规定的用户，经工作人员劝告无效者，工作人员有权终止其游玩本项目的资格。
          .copy 8.  在设备运行中如遇身体不适，请立即向工作人员示意，停止设备运行。
          .copy 9.  在设备运行中如遇突然停电或其他突发情况，请切勿慌张，保持冷静，必须听从工作人员指挥，安全疏导，有序下客。
          .copy 10. 允许2名成人同时体验，或2名成人陪同2名身高1M-1.2M儿童同时体验，其余人员禁止进入体验空间内，禁止在平台运动过程中站立在升降平台上方或体验空间内其他区域。         
        .title 互动区
        .body
          .copy 为了您的安全考虑，该区域体验建议您穿着平底运动鞋
      .term
        .title 未成年人游览特别须知
        .body
          .copy 如您为您未成年的子女购买门票，并携带未成年子女进入空间内游览，请注意：
          .copy (1)	您是该未成年人的法定监护人，遵守国家法律法规，服从空间站组织方的要求；
          .copy (2)	全程陪同并看护好未成年人，避免其自行活动遇到危险；
          .copy (3)	确保未成年人的身体健康，没有会影响参加活动的不适、损伤、病痛或其他疾病;
          .copy (4)	个别项目对身高有特殊要求，为保证未成年的安全，请遵守该规则。
          .copy 如有疑问，或遇紧急情况，请咨询空间站现场工作人员。          
      .term
        .title 期待您的光临！




</template>
<script>
import CloseBtn from '@/components/wedgits/CloseBtn'
export default {
  name: 'PopupNotice',
  components: { CloseBtn },
  props: {
    title: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.popup-notice
  position: fixed
  width: 100%
  height: 100%
  z-index: 9999
  top: 0
  left: 0
  +flex-center
  background: rgba(0, 0, 0, 0.46)
  animation: fadeIn 0.5s $easeOutCubic both
  .wrapper
    width: 85%
    height: 75%
    //height: pxToRem(229)
    background: white
    border-radius: pxToRem(20)
    position: relative
    padding: pxToRem(30)
    display: flex
    align-items: center
    flex-direction: column
    .close-btn
      right: pxToRem(40)
      top: pxToRem(40)
    .title
      text-align: center
      width: 100%
      //padding: pxToRem(40)
      font-size: pxToRem(36)
      color: black
      margin-bottom: pxToRem(30)
    .terms
      width: 100%
      flex: 1
      overflow-x: hidden
      overflow-y: scroll
      .term
        .title
          font-family: $ff-cn
          text-align: left
          font-size: 12px
          margin: pxToRem(30) 0
          font-weight: bold
        .body
          font-size: 12px
          .copy
            font-family: $ff-cn
            color: black
            //font-weight: lighter
          .interactive
            font-family: $ff-cn
            font-weight: bold
            color: black
@keyframes fadeIn
  0%
    transform: scale(1.2)
    opacity: 0
  100%
    transform: scale(1)
    opacity: 1
</style>
